module.exports = __webpack_public_path__ + "img/pf.06579c69.svg";